import React from "react";
import Container from "../styles/Container";
import { theme } from "../styles/theme";
import styled from "styled-components";
import { ItemsGrid } from "../styles/Grids";

const SubscribeSection = styled.section`
  background: var(--blue);
  padding-top: clamp(1em, 30vw, 4em);
  padding-bottom: clamp(1em, 30vw, 4em);
`;
const TextBox = styled.div`
  /* padding: 4rem; */

  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0 auto;
  h1 {
    font-size: clamp(2em, 10vw, 4em);

    color: var(--white);
  }
  small {
    font-family: Roboto;
    color: var(--white);
    margin: 3rem 0;
  }

  @media ${theme.devices.md} {
    width: 100%;
  }
`;

const Form = styled.div`
  display: flex;
  /* margin: 6rem 0; */
  /* align-items: center; */
  justify-content: flex-end;
  input {
    width: 100%;
    border-radius: 0.7rem;
    padding: 2rem 1rem;
    margin-right: -1rem;
    border: 1px solid var(--lightblue);
    box-shadow: ${theme.shadow.feature.small.default};

    font-family: Roboto;
    &:focus {
      border: 1px solid var(--lightblue);
      box-shadow: ${theme.shadow.feature.big.default};
    }
  }

  button {
    font-size: 2.4rem;
    padding: 1rem 3rem;
    outline: none;
    border: none;
    border-radius: 0.7rem;
    box-shadow: ${theme.shadow.feature.small.default};
  }
`;
const CouponBox = styled.div`
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 75%;
  margin: 2rem auto 0 auto;

  @media ${theme.devices.md} {
    margin: 0 auto;
  }

  border-radius: 0.7rem;
  background: rgba(255, 255, 255, 0.13);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);

  box-shadow: ${theme.shadow.feature.big.default};

  h1 {
    font-size: clamp(2em, 10vw, 4em);

    font-weight: 900;
    color: var(--lightblue);
  }
  p {
    font-size: 2rem;
    color: var(--white);
    font-weight: 200;
  }
`;

export default function Subscribe() {
  return (
    <SubscribeSection>
      <Container>
        <ItemsGrid>
          <TextBox>
            <h1>SUBSCRIBE TO GET WEEKLY UPDATES & DEALS!</h1>
            <small>
              We don't believe in spam. We believe in giving you sweet deals and
              clean cars.
            </small>
            <Form>
              <input type="email" placeholder="Email" />
              <button>submit</button>
            </Form>
          </TextBox>
          <CouponBox>
            <h1>30% OFF</h1>
            <p>Get up to 30% discount on your first car wash</p>
          </CouponBox>
        </ItemsGrid>
      </Container>
    </SubscribeSection>
  );
}
